module.exports = __webpack_public_path__ + "img/bali-background.22cc3f8a.jpg";